module.exports = __webpack_public_path__ + "static/media/seb.38b7b618.png";